import React, { useContext, useState,useEffect } from 'react'
import { useHistory } from "react-router-dom";


import { AppContext } from "../../AppContext";
import { fetchCall } from "../../common/FetchHelpers";

const NotificationComp = (props) => {

  const urlNotifications = "api/dashboard/notification";
  const urlNotificationVisited = "api/dashboard/notification/visited";

  const [appContext, setAppContext] = useContext(AppContext);
  const history = useHistory();

  const [showLoading, setShowLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  const handleNotificationDetail = (notification) => {
    setNotificationVisited(notification.id);
    props.handleClose();

    if (notification.msgType === 'EMP_ATTESTATION') {
      history.push(`/attestation/${notification.refId}`);
    } else if (notification.msgType === 'EMP_DOCUMENT') {
      history.push(`/documents/${notification.refId}/${Date.now()}`);
    }else if (notification.msgType === 'EMP_OBA') {
      history.push(`/oba/${notification.refId}/${Date.now()}`);
    }else if (notification.msgType === 'EMP_GIFT') {
      history.push(`/gift/${notification.refId}/${Date.now()}`);
    }else if (notification.msgType === 'EMP_POLITICAL') {
      history.push(`/political/${notification.refId}/${Date.now()}`);
    }
  }

  const setNotificationVisited = (idx) => {
    fetchCall(`${urlNotificationVisited}/${idx}`)
      .then((result) => {


        const readNotification = notifications.find(obj => obj.id === idx);
        if(readNotification){
          readNotification.visited = true;
          const unreadCount = notifications.filter(p=>!p.visited).length;
          setAppContext({...appContext, notificationCount:unreadCount})
          localStorage.setItem("NOTIFICATION_COUNT", unreadCount);
        }

      },
        (err) => {
          console.log(err);
        }
      );
  };

  useEffect(() => {
    setShowLoading(true);
    fetchCall(urlNotifications)
      .then(result => {
        setShowLoading(false);
        setNotifications(result);
      })
      .catch(err => {
        setShowLoading(false);
        //setError(true);
      })
  }, []);


  return (

    <div className="popup-dialog">


      <div className="offcanvas">
        <div className="tile-header">
                  <div className="offcanvas-title flex-1">Select to View Notification</div>
          <div className="offcanvas-action"><button className="btn-icon-small btn-cross" onClick={props.handleClose}></button></div>
        </div>

        <div className="offcanvas-body notifications">

          {(notifications && notifications.length > 0) &&

            <>
              <ul className="msg-list" id="message-list">

                {notifications.map((p) => {

                  const msgClass = p.visited ? 'msg-list-item msg-visited' : 'msg-list-item';

                  return (
                    <li
                     key={p.id}
                     className={msgClass}
                     data-id={p.id}
                     data-msgtype={p.msgType}
                     data-refid={p.refId}
                     data-visited={p.visited}
                     onClick={() => handleNotificationDetail(p)}>
                      <div className="msg-item">
                        <div className="flex">
                          <div className="msg-title flex-1">{p.title}</div>
                          <div className="msg-light-text">{p.time}</div>
                        </div>
                        <div className="msg-desc padt-8">{p.description}</div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </>

          }


        </div>

{showLoading && <div className='flex flex-center'>Please wait, Loading ...</div>}


        {(!(notifications && notifications.length > 0) &&
          <div className='flex flex-center'>No Notificatios available</div>
        )}

      </div>



    </div>



  )
}

export default NotificationComp;